import React from 'react';

export const HeaderContext = React.createContext({
  headerMetadata: {
    headerTitle: '',
    HeaderActions: () => null,
  },
  setHeaderMetadata: () => {},
});
